import React from 'react';
import { Container, Button, Box, Typography } from '@mui/material';


export const CompanyDetailsView = () => {
    return (
        <>
            <Container maxWidth="md" sx={{ textAlign: "left" }}>
                <Typography variant="h2" component="h2" sx={{ textAlign: "left", mt: 3, mb: 3 }}>
                    Реквизиты
                </Typography>
                <Typography variant="body1" sx={{fontSize: "24px"}}>
                    ОсОО "Нестарение Инвестмент"
                </Typography>

                <Typography variant="body1" sx={{mb: 2}}>
                    Кыргызская республика, г.Бишкек, Ленинский район, ул. Фрунзе 583, 6 этаж
                    <br />ИНН 02211202410560
                    <br />ОКПО 33477734
                    <br />Регистрационный номер 310807- 3301-ООО
                    <br />УГНС 002 по Ленинскому району
                </Typography>

                <Typography variant="body1" sx={{mb: 2}}>
                    Расчетный счет 1030120003617122
                    <br />ОАО «Коммерческий банк КЫРГЫЗСТАН» БИК 103001
                </Typography>

                <Typography variant="body1" sx={{mb: 2}}>
                    Генеральный директор ООО «Нестарение Инвестмент»
                    <br />Харламов Дмитрий Сергеевич
                </Typography>
            </Container>
        </>
    )
}
